module.exports = __webpack_public_path__ + "img/playMind.4869d037.svg";